export default __webpack_public_path__ + "static/media/no-per.145204ef.svg";